import { useAtomValue } from 'jotai'
import { useNavigate } from 'react-router-dom'
import { Button } from '@/components/ui/button'
import { appLink } from '@app/config/appLink'
import { usePrefillWorkspaceFromMap } from '@app/modules/Risk/Workspaces/hooks/usePrefillWorkspaceFromMap'
import { workspaceDiffersFromMap } from '@app/modules/Risk/Workspaces/workspace.utils'
import { riskLayersAtom } from '@app/risk-migration/atoms/riskLayers.atoms'
import {
  activeWorkspaceAtom,
  activeWorkspaceLayerIdsAtom,
} from '@app/risk-migration/atoms/riskMap.atoms'
import { useRiskFilterState } from '@app/risk-migration/hooks/useRiskFilterState'

export const SaveWorkspaceButton = ({ className }: { className?: string }) => {
  const navigate = useNavigate()
  const activeWorkspace = useAtomValue(activeWorkspaceAtom)
  const activeWorkspaceLayerIds = useAtomValue(activeWorkspaceLayerIdsAtom)
  const mapLayers = useAtomValue(riskLayersAtom)
  const { regionMasks } = useRiskFilterState()
  const { prefillWorkspace } = usePrefillWorkspaceFromMap()

  // Compare against the selected sets' layers, not the whole workspace
  const hasChanges =
    !activeWorkspace ||
    workspaceDiffersFromMap(
      activeWorkspace,
      mapLayers,
      regionMasks?.map(({ region }) => region) ?? [],
      activeWorkspaceLayerIds ?? activeWorkspace.layers,
    )

  const handleSaveAs = () => {
    prefillWorkspace()
    navigate(appLink.workspacesCreate.path, { state: { fromRiskMap: true } })
  }

  return (
    <Button className={className} onClick={handleSaveAs} variant="ghost" disabled={!hasChanges}>
      Save as workspace
    </Button>
  )
}
